module.exports = __webpack_public_path__ + "static/Mist_Vampiric-3be9b9c9cde702a93563b31c9a40a5e9.jpg";